import { defineComponent as _defineComponent } from 'vue'
import { normalizeClass as _normalizeClass, createVNode as _createVNode, createElementVNode as _createElementVNode, unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderSlot as _renderSlot, toDisplayString as _toDisplayString, withCtx as _withCtx, createBlock as _createBlock, normalizeStyle as _normalizeStyle, createTextVNode as _createTextVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-00549f4e"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["id"]
const _hoisted_2 = { class: "tw-grid tw-grid-cols-5 gap-3" }
const _hoisted_3 = { class: "tw-col-span-5 md:tw-col-span-3 xl:tw-col-span-4" }
const _hoisted_4 = { class: "tw-flex tw-gap-[15px] tw-w-full" }
const _hoisted_5 = {
  class: /*#__PURE__*/_normalizeClass(`tw-flex tw-items-center tw-justify-start tw-gap-[15px] tw-h-[fit-content] tw-mt-[2px]`)
}
const _hoisted_6 = {
  class: /*#__PURE__*/_normalizeClass(`tw-flex tw-flex-col tw-gap-[20px] tw-w-full questionWrapper`)
}
const _hoisted_7 = {
  key: 0,
  class: "prefilled"
}
const _hoisted_8 = { class: "tw-flex tw-justify-between tw-items-center" }
const _hoisted_9 = { class: "tw-flex tw-gap-[15px]" }
const _hoisted_10 = { class: "tw-flex tw-items-center tw-gap-[10px] tw-text-[#231F20] tw-text-[16px] tw-not-italic tw-font-normal tw-leading-[normal]" }
const _hoisted_11 = ["data-id"]
const _hoisted_12 = {
  key: 0,
  class: "info-icon tw-ml-[15px] md:tw-ml-[25px]"
}
const _hoisted_13 = { class: "tw-p-[15px] tw-w-[475px]" }
const _hoisted_14 = { class: "tw-flex tw-flex-col tw-gap-4 tw-text-[11px] tw-font-[400] tw-text-[#231F20]" }
const _hoisted_15 = { key: 0 }
const _hoisted_16 = { class: "tw-text-[14px] tw-font-semibold tw-text-[#211f58] tw-font-poppins" }
const _hoisted_17 = { key: 1 }
const _hoisted_18 = { class: "tw-text-[14px] tw-font-semibold tw-text-[#211f58] tw-font-poppins" }
const _hoisted_19 = {
  key: 0,
  class: "prefilled"
}
const _hoisted_20 = ["id"]
const _hoisted_21 = { class: "tw-col-span-5 md:tw-col-span-2 xl:tw-col-span-1" }
const _hoisted_22 = { class: "tw-flex tw-items-center tw-justify-end tw tw-w-[100%] tw-h-full tw-gap-[20px]" }
const _hoisted_23 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("path", {
  d: "M11.8741 6.38894L6.38429 0.165448C6.33485 0.113191 6.27527 0.0715663 6.2092 0.0431191C6.14312 0.0146718 6.07194 -2.59124e-07 6 -2.62268e-07C5.92806 -2.65413e-07 5.85688 0.0146718 5.7908 0.0431191C5.72473 0.0715663 5.66515 0.113191 5.61571 0.165448L0.125859 6.38894C0.081969 6.43838 0.0483386 6.49604 0.02692 6.55858C0.00550146 6.62113 -0.00327902 6.6873 0.00108975 6.75327C0.0065009 6.81976 0.0251891 6.8845 0.056049 6.94364C0.086909 7.00279 0.129313 7.05515 0.180757 7.09763L1.10405 7.8712C1.15449 7.91483 1.21315 7.9479 1.27658 7.96848C1.34002 7.98905 1.40693 7.9967 1.47337 7.99098C1.53949 7.9862 1.604 7.96828 1.66313 7.93829C1.72225 7.9083 1.77481 7.86683 1.81773 7.8163L5.91516 3.10002C5.94039 3.07503 5.97447 3.06101 6.00998 3.06101C6.04549 3.06101 6.07957 3.07503 6.10481 3.10002L10.1823 7.8163C10.2629 7.91267 10.377 7.97505 10.5017 7.99098C10.5678 7.99738 10.6345 7.99052 10.6979 7.97081C10.7613 7.9511 10.8202 7.91893 10.871 7.87619L11.8192 7.09763C11.8707 7.05515 11.9131 7.00279 11.9439 6.94364C11.9748 6.8845 11.9935 6.81976 11.9989 6.75327C12.0033 6.6873 11.9945 6.62113 11.9731 6.55859C11.9517 6.49604 11.918 6.43838 11.8741 6.38894Z",
  fill: "#DBDBDB"
}, null, -1))
const _hoisted_24 = [
  _hoisted_23
]
const _hoisted_25 = {
  key: 1,
  class: /*#__PURE__*/_normalizeClass(`tw-flex tw-items-center tw-justify-end tw tw-w-[100%] tw-gap-[20px]`)
}
const _hoisted_26 = {
  key: 0,
  class: "tw-flex tw-items-center tw-gap-[20px] others"
}
const _hoisted_27 = {
  key: 1,
  class: "tw-flex tw-gap-[20px]"
}

import {
  Ref,
  ref,
  computed,
  PropType,
  ComputedRef,
  onMounted,
  watch,
} from "vue";
import ToggleIcon from "../svgs/toggleIcon.vue";
import {
  TYPE_ASSESSMENT_VIEW_STYLE,
  assessmentQuestionVisibleState,
  statusCode,
} from "@/utils/constants";
import WYSiwygEditor from "@/components/common/wysiwygEditor.vue";
import PinIcon from "../svgs/pinIcon.vue";
import PenIcon from "../svgs/penIcon.vue";
import CircularProgressPercent from "../common/circularProgressPercent.vue";
import AssessmentQuestionPrefilledTag from "../assessment/assessmentQuestionPrefilledTag.vue";
import AssessmentQuestionNotApplicableTag from "../assessment/assessmentQuestionNotApplicableTag.vue";
import ExpandingButton from "../common/expandingButton.vue";
import { getComponentUiText } from "@/utils/utilities";
import ButtonShowMore from "../common/setting/buttonShowMore.vue";
import CustomDropDownItem from "../common/customDropDownItem.vue";
import Button4 from "../common/button4.vue";
import store from "@/store";
import { useRoute } from "vue-router";
import { addItemFromMaster } from "@/services/assessment";
import ButtonShowDuplicateAssessment from "../common/setting/buttonShowDuplicateAssessment.vue";
import CustomDescriptionContent from "../common/customDescriptionContent.vue";
import EventEmitter, { EmitterEvents } from "@/utils/eventEmitter";
import { Handler } from "mitt";
import VendorAssessmentQuestionEvaluate from "../vendor/vendorAssessmentQuestionEvaluate.vue";
import StatusBadge from "../common/setting/statusBadge.vue";
import { debounce } from "lodash";


export default /*#__PURE__*/_defineComponent({
  __name: 'vendorAssessmentQuestionTextArea',
  props: {
  selectedQuestions: {
    type: Array as () => number[],
    default: () => [],
  },
  checklistItem: {
    type: Object,
    default: () => ({}),
  },
  viewStyle: {
    type: String as PropType<keyof typeof TYPE_ASSESSMENT_VIEW_STYLE>,
    default: TYPE_ASSESSMENT_VIEW_STYLE.user,
  },
  placeholder: {
    type: String,
    default: "",
  },
  isSelectedAll: {
    type: Boolean,
    default: false,
  },
},
  emits: [
  "openEvidenceModal",
  "exclude",
  "update:selected",
  "showModalAddNoteAssessment",
  "uploadFile",
  "showAdvanceModal",
],
  setup(__props, { emit: emits }) {

const props = __props;



let setTimeOutRef: any = null;
const route = useRoute();
const id = Number(route.params.assessmentId);
const onHover: Ref<boolean> = ref(false);
const isCollapsed: Ref<boolean> = ref(true);
const passkeyQuestion: Ref<string> = ref("");
const notesValue = ref(props.checklistItem.checklistItemNotes || "");
let currenNotesValue = props.checklistItem.checklistItemNotes;

const checklistItemDataRaw = computed(() => {
  return props.checklistItem;
});

const isSelected: Ref<boolean> = ref(false);
const isExclude: Ref<boolean> = computed(() => {
  return (
    checklistItemDataRaw.value?.visibleState ===
    assessmentQuestionVisibleState.no
  );
});

const evaluateOptions = computed(() => {
  const data = store.state.Assessment.assessmentQuestionTypes?.find(
    (item) =>
      item.id === checklistItemDataRaw.value?.checklistItemComplianceTypeOrgId,
  );

  if (!data) return [];

  return data.complianceTypeValues;
});

const evaluateAnswer: Ref = ref(
  checklistItemDataRaw.value?.checklistItemComplianceTypeValueOrgId
    ? checklistItemDataRaw.value?.checklistItemComplianceTypeValueOrgId
    : null,
);

const getLabelEvaluateTag = () => {
  const selected = evaluateOptions.value.find(
    (item) => item.id === evaluateAnswer.value,
  );

  return selected?.label;
};

const getValueEvaluateTag = () => {
  const selected = evaluateOptions.value.find(
    (item) => item.id === evaluateAnswer.value,
  );

  if (!selected) return "";
  if (selected?.order === 1) return statusCode.notAccepted;
  if (selected?.order === 2) return statusCode.informationRequired;
  if (selected?.order === 3) return statusCode.accepted;
};

const handleSelectedEvaluateAnswer = (value) => {
  if (value["complianceTypeValueOrgId"])
    evaluateAnswer.value = value["complianceTypeValueOrgId"];
};

const handleFocusoutUpdateNote = debounce(async () => {
  if (notesValue.value === currenNotesValue) return;
  const res = await store.dispatch("Vendor/updateRequestedItems", {
    id: Number(route.params.assessmentId),
    values: [
      {
        notes: notesValue.value,
        checklistRequestedItemId: checklistItemDataRaw.value.checklistItemId,
      },
    ],
  });

  if (!res) {
    notesValue.value = currenNotesValue;
  }
}, 450);

const handleUpdateNote = debounce((value: string) => {
  notesValue.value = value;
}, 450);

const isChecklistCompleted: ComputedRef<boolean> = computed(() => false);
const onHoverIn = () => {
  if (setTimeOutRef) clearTimeout(setTimeOutRef);
  onHover.value = true;
};
const onHoverOut = () => {
  setTimeOutRef = setTimeout(() => {
    onHover.value = false;
  }, 150);
};

const showAdvanceModal = () => {
  emits("showAdvanceModal", passkeyQuestion.value);
};
onMounted(() => initial());
const initial = () => {
  EventEmitter.on(EmitterEvents.UPDATE_PASSWORD_ASSESSMENT_QUESTION, ((data: {
    password: string;
    checklistItemId: number;
  }) => {
    if (
      data.password &&
      data.checklistItemId === checklistItemDataRaw.value.checklistItemId
    ) {
      passkeyQuestion.value = data.password;
    }
  }) as Handler<unknown>);
};
// const addItemAction = async () => {
//   const res = await addItemFromMaster(Number(route.query.checklistId), [
//     checklistItemDataRaw.value.checklistItemId,
//   ]);
//   if (res) {
//     const params = {
//       checklistIdParam: Number(route.query.checklistId),
//       showMasterItem: true,
//     };
//     store.dispatch("Assessment/fetchChecklistByCategory", params);
//   }
// };
const handleSelectedQuestions = () => {
  if (isExclude.value || checklistItemDataRaw.value.checklistItemIsNa) return;
  isSelected.value = !isSelected.value;
  emits("update:selected", {
    isSelected: isSelected.value,
  });
};

watch(
  () => props.isSelectedAll,
  (value) => {
    isSelected.value = value;
  },
);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    id: `vendor-assessment-text-area-heading-${checklistItemDataRaw.value.checklistItemId}`,
    class: _normalizeClass(`tw-flex tw-flex-col tw-border-0 tw-border-b tw-border-solid tw-border-[#EFF0F1] tw-rounded-t-[6px] assessmentQuestion tw-text-[#231F20] tw-text-base tw-font-[Poppins]`),
    onMouseover: onHoverIn,
    onMouseout: onHoverOut
  }, [
    _createElementVNode("div", {
      class: _normalizeClass(`tw-w-full tw-p-[15px] md:tw-p-[25px] question ${
        isSelected.value ? 'tw-bg-[rgba(242,248,255,0.5)]' : ''
      }`)
    }, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("div", _hoisted_5, [
              _createVNode(ToggleIcon, {
                id: `vendor-assessment-text-area-radio-heading-${checklistItemDataRaw.value.checklistItemId}`,
                class: _normalizeClass(`${
                  isExclude.value || checklistItemDataRaw.value.checklistItemIsNa
                    ? `tw-opacity-50`
                    : 'tw-cursor-pointer'
                }`),
                ticked: isSelected.value,
                color: "#387dff",
                onClick: handleSelectedQuestions
              }, null, 8, ["id", "class", "ticked"])
            ]),
            _createElementVNode("div", _hoisted_6, [
              (
                  checklistItemDataRaw.value?.visibleState ===
                  _unref(assessmentQuestionVisibleState).prefilled
                )
                ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                    _createVNode(AssessmentQuestionPrefilledTag, {
                      "number-question": '',
                      color: "green",
                      expand: !isCollapsed.value
                    }, null, 8, ["expand"])
                  ]))
                : _createCommentVNode("", true),
              _createElementVNode("div", _hoisted_8, [
                _createElementVNode("div", _hoisted_9, [
                  _createElementVNode("div", _hoisted_10, [
                    _createElementVNode("p", {
                      class: _normalizeClass(`text-with-icon ${
                        isExclude.value || checklistItemDataRaw.value.checklistItemIsNa
                          ? `greyed`
                          : ''
                      }`)
                    }, [
                      _renderSlot(_ctx.$slots, "default", {}, () => [
                        _createElementVNode("span", {
                          class: "tw-text-[#231F20] tw-text-base tw-font-[Poppins]",
                          "data-cy": "question-name",
                          "data-id": `${checklistItemDataRaw.value.checklistItemId}`
                        }, _toDisplayString(checklistItemDataRaw.value.checklistItemHeadingLabel ||
                            checklistItemDataRaw.value.checklistItemName) + " " + _toDisplayString(checklistItemDataRaw.value.subName
                              ? ` | ${checklistItemDataRaw.value.subName}`
                              : ""), 9, _hoisted_11)
                      ]),
                      (
                          (checklistItemDataRaw.value.checklistItemDescription ||
                            checklistItemDataRaw.value.checklistItemGuidance) &&
                          onHover.value
                        )
                        ? (_openBlock(), _createElementBlock("span", _hoisted_12, [
                            _createVNode(ButtonShowDuplicateAssessment, {
                              "id-popover": 'popover' + Math.random() * 1000,
                              "custom-class": 'tw-w-[max-content] tw-min-w-[500px] md:tw-max-w-[350px] lg:tw-max-w-[470px]',
                              class: _normalizeClass(`!tw-p-0 tw-leading-[16px]`),
                              classes: `!tw-leading-none tw-flex tw-items-center tw-justify-center`
                            }, {
                              default: _withCtx(() => [
                                _createElementVNode("div", _hoisted_13, [
                                  _createElementVNode("div", _hoisted_14, [
                                    (
                                  checklistItemDataRaw.value.checklistItemDescription
                                )
                                      ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
                                          _createElementVNode("div", _hoisted_16, _toDisplayString(_unref(getComponentUiText)(
                                      "app-menu-submenu-assessments-further-information-1",
                                    )), 1),
                                          _createVNode(CustomDescriptionContent, {
                                            description: 
                                    checklistItemDataRaw.value.checklistItemDescription
                                  ,
                                            class: _normalizeClass(`!tw-p-0 tw-text-[13px] tw-text-[#878787]`)
                                          }, null, 8, ["description"])
                                        ]))
                                      : _createCommentVNode("", true),
                                    (
                                  checklistItemDataRaw.value.checklistItemGuidance
                                )
                                      ? (_openBlock(), _createElementBlock("div", _hoisted_17, [
                                          _createElementVNode("div", _hoisted_18, _toDisplayString(_unref(getComponentUiText)(
                                      "app-menu-submenu-assessments-guidance-1",
                                    )), 1),
                                          _createVNode(CustomDescriptionContent, {
                                            description: 
                                    checklistItemDataRaw.value.checklistItemGuidance
                                  ,
                                            class: _normalizeClass(`!tw-p-0 tw-text-[13px] tw-text-[#878787]`)
                                          }, null, 8, ["description"])
                                        ]))
                                      : _createCommentVNode("", true)
                                  ])
                                ])
                              ]),
                              _: 1
                            }, 8, ["id-popover"])
                          ]))
                        : _createCommentVNode("", true)
                    ], 2),
                    (checklistItemDataRaw.value.checklistItemIsNa)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_19, [
                          _createVNode(AssessmentQuestionNotApplicableTag, {
                            color: "grey",
                            expand: !isCollapsed.value
                          }, null, 8, ["expand"])
                        ]))
                      : _createCommentVNode("", true),
                    (evaluateAnswer.value)
                      ? (_openBlock(), _createBlock(StatusBadge, {
                          key: 1,
                          class: "tw-w-fit",
                          "data-cy": `status-badge-lable-${checklistItemDataRaw.value.checklistItemId}`,
                          "lable-class": `tw-max-w-fit`,
                          label: getLabelEvaluateTag() ?? '',
                          value: getValueEvaluateTag() ?? ''
                        }, null, 8, ["data-cy", "label", "value"]))
                      : _createCommentVNode("", true)
                  ])
                ])
              ]),
              _createElementVNode("div", {
                id: `vendor-assessment-text-area-editor-${checklistItemDataRaw.value.checklistItemId}`,
                class: _normalizeClass(`tw-max-w-[94%] md:tw-max-w-[95%] lg:tw-max-w-[965px] ${
                  checklistItemDataRaw.value.checklistItemIsNa
                    ? 'tw-pointer-events-none'
                    : ''
                }`)
              }, [
                _createVNode(WYSiwygEditor, {
                  modelValue: notesValue.value,
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((notesValue).value = $event)),
                  "include-image": false,
                  "is-disabled": isChecklistCompleted.value,
                  "custom-class": `xl:tw-max-w-[calc(100%-130px)] 2xl:tw-max-w-[calc(100%-50px)]`,
                  "onUpdate:blur": _unref(handleFocusoutUpdateNote),
                  "onUpdate:value": _cache[1] || (_cache[1] = ($event) => _unref(handleUpdateNote)($event))
                }, null, 8, ["modelValue", "is-disabled", "custom-class", "onUpdate:blur"])
              ], 10, _hoisted_20)
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_21, [
          _createElementVNode("div", _hoisted_22, [
            (
                checklistItemDataRaw.value?.visibleState ===
                  _unref(assessmentQuestionVisibleState).prefilled &&
                !checklistItemDataRaw.value.checklistItemIsNa
              )
              ? (_openBlock(), _createElementBlock("span", {
                  key: 0,
                  class: "tw-cursor-pointer tw-absolute md:tw-relative md:tw-top-[unset] tw-top-[22px] tw-right-[18px] arrow",
                  onClick: _cache[2] || (_cache[2] = ($event: any) => (isCollapsed.value = !isCollapsed.value))
                }, [
                  (_openBlock(), _createElementBlock("svg", {
                    xmlns: "http://www.w3.org/2000/svg",
                    width: "12",
                    height: "8",
                    viewBox: "0 0 12 8",
                    fill: "none",
                    style: _normalizeStyle(isCollapsed.value ? 'transform: rotate(180deg)' : '')
                  }, _hoisted_24, 4))
                ]))
              : _createCommentVNode("", true),
            (
                !(
                  checklistItemDataRaw.value?.visibleState ===
                  _unref(assessmentQuestionVisibleState).prefilled
                ) || !isCollapsed.value
              )
              ? (_openBlock(), _createElementBlock("div", _hoisted_25, [
                  (!isExclude.value && onHover.value)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_26, [
                        _createVNode(ExpandingButton, {
                          id: `vendor-assessment-text-area-btn-note-${checklistItemDataRaw.value.checklistItemId}`,
                          color: "#387DFF",
                          icon: PenIcon,
                          text: 
                    _unref(getComponentUiText)(
                      'app-component-assessments-override-question-note-title-1',
                    )
                  ,
                          onClick: showAdvanceModal
                        }, null, 8, ["id", "text"]),
                        _createVNode(ExpandingButton, {
                          id: `vendor-assessment-text-area-btn-evidence-${checklistItemDataRaw.value.checklistItemId}`,
                          class: _normalizeClass(
                    isChecklistCompleted.value &&
                    checklistItemDataRaw.value.checklistItemAttachments?.length === 0
                      ? '!tw-transform-none'
                      : ''
                  ),
                          color: 
                    isChecklistCompleted.value &&
                    checklistItemDataRaw.value.checklistItemAttachments?.length === 0
                      ? '#62a2f5'
                      : '#387DFF'
                  ,
                          icon: PinIcon,
                          text: 
                    _unref(getComponentUiText)(
                      'app-component-assessments-evidence-button-title-1',
                    )
                  ,
                          "max-width": "95px",
                          onClick: showAdvanceModal
                        }, null, 8, ["id", "class", "color", "text"]),
                        _createElementVNode("div", null, [
                          _createVNode(ButtonShowMore, {
                            "id-popover": `vendor-assessment-text-area-btn-popover-${checklistItemDataRaw.value.checklistItemId}`,
                            classes: `!tw-p-[0px]`
                          }, {
                            default: _withCtx(() => [
                              (__props.viewStyle !== _unref(TYPE_ASSESSMENT_VIEW_STYLE).vendor)
                                ? (_openBlock(), _createBlock(CustomDropDownItem, {
                                    key: 0,
                                    style: _normalizeStyle(`tw-self-center ${
                        isChecklistCompleted.value
                          ? '!tw-cursor-not-allowed normal'
                          : 'normal'
                      }`),
                                    "id-text": 'app-component-vendor-question-advance-option-1',
                                    "style-text": '!tw-self-auto',
                                    onClick: showAdvanceModal
                                  }, null, 8, ["style"]))
                                : _createCommentVNode("", true)
                            ]),
                            _: 1
                          }, 8, ["id-popover"])
                        ])
                      ]))
                    : _createCommentVNode("", true),
                  (
                  checklistItemDataRaw.value.itemCompleteValue !== undefined ||
                  isExclude.value
                )
                    ? (_openBlock(), _createElementBlock("div", _hoisted_27, [
                        (checklistItemDataRaw.value.itemCompleteValue !== undefined)
                          ? (_openBlock(), _createBlock(CircularProgressPercent, {
                              key: 0,
                              id: `vendor-assessment-text-area-circular-percent-${checklistItemDataRaw.value.checklistItemId}`,
                              "data-cy": `circular-percent-${checklistItemDataRaw.value.checklistItemId}`,
                              percent: checklistItemDataRaw.value.itemCompleteValue,
                              "compensating-override-score": 
                    checklistItemDataRaw.value.checklistItemCompensatingControlValue
                  ,
                              "compliance-override-score": 
                    checklistItemDataRaw.value.checklistItemComplianceOverride
                  ,
                              class: _normalizeClass('tw-cursor-pointer'),
                              excluded: isExclude.value,
                              size: 44,
                              "text-size": 11
                            }, null, 8, ["id", "data-cy", "percent", "compensating-override-score", "compliance-override-score", "excluded"]))
                          : _createCommentVNode("", true),
                        (isExclude.value)
                          ? (_openBlock(), _createBlock(Button4, {
                              key: 1,
                              id: `vendor-assessment-text-area-circular-percent-${checklistItemDataRaw.value.checklistItemId}`,
                              class: _normalizeClass(`tw-self-center ${
                    isChecklistCompleted.value ? '!tw-cursor-not-allowed' : ''
                  }`)
                            }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(_unref(getComponentUiText)("app-component-assessments-include-1")), 1)
                              ]),
                              _: 1
                            }, 8, ["id", "class"]))
                          : _createCommentVNode("", true)
                      ]))
                    : _createCommentVNode("", true)
                ]))
              : _createCommentVNode("", true)
          ])
        ])
      ])
    ], 2),
    _createElementVNode("div", null, [
      _createVNode(VendorAssessmentQuestionEvaluate, {
        id: `vendor-assess-review-question-evaluate-text-area-${checklistItemDataRaw.value.checklistItemId}`,
        "id-question": `${checklistItemDataRaw.value.checklistItemId}`,
        class: "tw-mx-0",
        "checklist-item-data-raw": checklistItemDataRaw.value,
        "is-checklist-completed": isChecklistCompleted.value,
        "id-dropdown": `vendor-assess-review-question-evaluate-dropdown-${checklistItemDataRaw.value.checklistItemId}`,
        "id-note-input": `vendor-assess-review-question-evaluate-note-input-${checklistItemDataRaw.value.checklistItemId}`,
        "id-percent-input": `vendor-assess-review-question-evaluate-percent-input-${checklistItemDataRaw.value.checklistItemId}`,
        "background-input": `white`,
        "is-show-label": false,
        "onUpdate:evaluateAnswer": handleSelectedEvaluateAnswer
      }, null, 8, ["id", "id-question", "checklist-item-data-raw", "is-checklist-completed", "id-dropdown", "id-note-input", "id-percent-input"])
    ])
  ], 40, _hoisted_1))
}
}

})